import { defaultConfig } from '@formkit/vue'
import { createProPlugin, inputs } from '@formkit/pro'
import { genesisIcons } from '@formkit/icons'
import { rootClasses } from './formkit.theme'

const pro = createProPlugin('fk-81dc236c23', inputs)

// Single source of truth for FormKit setup - imported once by resources/js/app.js.
//
// `icons` is registered locally on purpose. Without it FormKit falls back to its
// runtime iconLoader, which fetches each icon from cdn.formk.it on demand; when that
// request doesn't complete the control buttons render as blank-but-clickable squares
// (this is what hid the repeater's remove/add/reorder controls). This app is a PWA
// used on-site, so it must not depend on a CDN round trip just to draw a delete button.
export default defaultConfig({
    plugins: [pro],
    icons: { ...genesisIcons },
    config: {
        rootClasses,
    },
})
